<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-06-07 11:11:01
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-06-07 13:43:44
-->
<template>
  <div class="pt-24 pb-30 conf-block">
    <div class="flex-row flex-align-center flex-just-between">
      <p class="fz-16 yx-pingfang-semibold flex-row flex-align-center mb-24"><img :src="iconUrl" alt="" v-if="iconUrl" height="20" class="mr-6">{{title}}</p>
      <slot name="extra"></slot>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'ConfBlock',
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  computed: {
    iconUrl() {
      return this.icon ? require(`@/assets/public/${this.icon}.png`) : '';
    }
  }
}
</script>
<style lang="less">
.conf-block {
  padding-right: 54px;
  & + & {
    border-top: 1px solid #EEEEEE;
  }
}
</style>